import gql from 'graphql-tag'

const query = gql`query activation ($brand: String = "", $msisdn: String = "") {
  availablePreactivePromotions(brand: $brand, , msisdn: $msisdn, promotionCode: null) {
    bookablePromotion {
      ...fullPromo
    }
    inclusivePromotion {
      ...fullPromo
    }
    statusInfo
  }
}
fragment fullPromo on BookablePromotion {
  promotionId
  name
  description
  context
  bandwidth {
    up
    down
    unit
    throttled
    throttledUnit
    tech
    formattedUnit
    formattedThrottledUnit
  }
  volumes {
    formattedUnit
    type
    amount
    unit
  }
  incentives {
    id
    title
    description
    type
    ...on ServiceIncentive {
      service
    }
    ...on CreditIncentive {
      discount
      targetId
      targetEntity
      targetFee
      creditTarget: target
    }
    ...on OtherIncentive {
      kind
    }
    ...on VolumeIncentive {
      volumeTarget: target
      amount
      unit
    }
  }
  frontendContext
  notBookableWith
  requiredParameters
  criteria {
    tariffIds
    mnpProvider
    tariffoptionIds
  }
  duration {
    amount
    unit
    formattedUnit
  }
}`
export default query
